import { AfterContentChecked, AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import axios from 'src/app/Service/axios';

import Feature from 'ol/Feature';

import { Icon, Stroke, Style } from 'ol/style';

import { BingMaps } from 'ol/source';

import TileLayer from 'ol/layer/Tile';

import VectorLayer from 'ol/layer/Vector';

import VectorSource from 'ol/source/Vector';

import * as olProj from 'ol/proj';

import { LineString, MultiPoint, Point } from 'ol/geom';

import Vector from 'ol/source/Vector';

import Map_ol from 'ol/Map';

import View from 'ol/View';

import OSM from 'ol/source/OSM';

import axios1 from 'axios'

import { Text, Fill } from 'ol/style';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { Router } from '@angular/router';

declare let $: any;


@Component({

  selector: 'app-trip-management',

  templateUrl: './trip-management.component.html',

  styleUrls: ['./trip-management.component.css']

})

export class TripManagementComponent implements OnInit {

  isLoading: boolean = false;

  isEditComp: boolean = false;

  bCluster: boolean = false;

  menuType: string = 'confirm';

  trips: any;

  list_Search: any;

  drivers: any;

  lstDriver_Search: any;

  driver: any;

  source: any;

  vector: any;

  layers: any = [];

  lstPassenger: any = [];

  lst_DriverPlan: any = [];

  map: any;

  vectorLayer: any;

  currentRecord: any;

  tiType: number = -1;

  clusterColorMap = new Map<number, string>();

  @ViewChild('selectTab') selectTab: ElementRef | undefined;

  constructor(private formBuilder: FormBuilder, private notify: NotificationService, private otherService: OtherService, private gurdService: GurdServiceService, private router: Router) { }

  path: FormGroup = this.formBuilder.group({
    duration: new FormControl(''),
    distance: new FormControl('')
  })

  mdl_Cluster: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    tiAppUsage: new FormControl('1', Validators.required),

    tiTripStatus: new FormControl('1', Validators.required),

    tiPassengers: new FormControl('4', Validators.required),

    fMaxDistanceInKm: new FormControl('2', Validators.required),

    iMinute: new FormControl('30', Validators.required),

  })

  ngOnInit(): void {

    this.setActiveTab(this.menuType)
  }

  async sendSmsToDriver() {
    let val = document.getElementById('smstextHolder') as HTMLInputElement;
    if (!val.value)
      return this.notify.showError('متن پیامک نمیتواند خالی باشد');

    let model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      iOffitialTrip: this.currentRecord.iOfficialTrip,
      strSMS: val.value
    }

    let res = JSON.parse((await axios.post(`OffitialTrip_SendSMS2Driver`, model)).data.toString());
    if (!res.iResult)
      return this.notify.showError('خطایی در ارسال پیامک پیش آمده!');

    this.notify.showSuccess('پیامک با موفقیت ارسال شد');
    $('#sendSmsModal').modal('hide');
  }

  selectDriver(item: any) {

    $.confirm({

      title: `مشخصات خودرو انتخاب شده`,

      content: `<section class="border rounded border-secondary p-2">

      نام راننده: ${item.strFullName} <br>

      خودرو: ${item.strGPSType_strComment} <br>

      حوزه خدمت: ${item.strMobileDomain_strComment} <br>

      </section>

      <br>

      <span class="mt-0">در صورت صحت اطلاعات دکمه "تأیید" را فشار دهید</span>

      `,
      type: 'red',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-success',

          keys: ['enter'],

          action: async () => {

            let model = this.otherService.stringNumberToNumber({

              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              iOffitialTrip: this.currentRecord?.iOfficialTrip,

              strUnitID: item.strUnitID,

              lstiOffitialTrip: this.lstPassenger,

              tiType: this.tiType

            })

            let res = JSON.parse((await axios.post(`OffitialTrip_AssignDriver`, this.otherService.stringNumberToNumber(model))).data.toString());

            if (res.iResult == 1) {

              this.notify.showSuccess('به سفر مد نظر خودرو تخصیص داده شد');

              $('#DriverAssignModal').modal('hide');

              setTimeout(() => {

                this.setActiveTab('DriverConfirm');

              }, 500);

            }

            else {

              this.notify.showError(res.strError);
            }

          }

        },

        cancel: {
          text: "لغو",
        }
      }

    });

  }

  async getDriversList(item: any = null, isAll: boolean = false) {

    this.currentRecord = item;

    this.otherService.Showspinner();

    let model = {

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      iOffitialTrip: item?.iOfficialTrip || -1,

      lstiOffitialTrip: this.lstPassenger,

      tiType: this.tiType,

      bAll: isAll

    }

    let res = JSON.parse((await axios.post(`OffitialTrip_DriverList`, this.otherService.stringNumberToNumber(model))).data.toString());

    this.drivers = res;

    this.lstDriver_Search = res;

    this.otherService.nonespinner();

    $('#DriverAssignModal').modal('show');

  }

  //reject trip

  async setTripRejection(modalName: any, item?: any) {

    if (item) {

      if (confirm(`آیا از لغو سفر با کد ${item.iOfficialTrip} اطمینان دارید؟`)) {

        let model = this.otherService.stringNumberToNumber({

          strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

          iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

          iOffitialTrip: item.iOfficialTrip,

        })

        let res = JSON.parse((await axios.post(`OffitialTrip_Cancel`, model)).data.toString());

        if (res.strError) return this.notify.showError(res.strError);

        this.notify.showSuccess('سفر مورد نظر با موقت لغو شد');

        this.setActiveTab(this.menuType);

      }

    }

    else {

      if (confirm(`آیا از لغو سفر با کد ${this.currentRecord.iOfficialTrip} اطمینان دارید؟`)) {

        let model = this.otherService.stringNumberToNumber({

          strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

          iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

          iOffitialTrip: this.currentRecord.iOfficialTrip,

        })

        let res = JSON.parse((await axios.post(`OffitialTrip_Cancel`, model)).data.toString());

        if (res.strError) return this.notify.showError(res.strError)

        this.notify.showSuccess('سفر مورد نظر با موقت لغو شد');

        $(`#${modalName}`).modal('hide');

        this.setActiveTab(this.menuType);

      }

    }

  }

  showDetailsModal(item: any, isEdit: boolean) {

    if (isEdit) {

      this.isEditComp = true;

      this.currentRecord = item;

      $('#tripModal').modal('show');

    }

    else {

      this.currentRecord = item;

      $('#tripModal').modal('show');

    }

  }

  closeEditTrip(tripObj?: any, isApp?: boolean) {

    if (isApp) {

      let trip = this.trips.filter((el: any) => {

        return el.iOfficialTrip == tripObj.iOfficialTrip

      })

      const iTrip = this.trips.indexOf(trip[0]);

      if (iTrip != -1) this.trips[iTrip] = tripObj;

      this.isEditComp = false;

      $('#tripModal').modal('hide');

    }

    else {

      setTimeout(() => {

        this.isEditComp = false;

        $('#tripModal').modal('hide');

      }, 100);

    }


  }

  newMapShowTripSourceAndDest(item: any) {
    $('#maplat1').modal('show');
    if (this.map)
      this.map.setTarget(null);
    setTimeout(() => {
      this.map = new Map_ol({
        target: 'map',
        layers: [
          new TileLayer({
            source: new OSM()
          })
        ],
        view: new View({
          center: olProj.fromLonLat([item.fsLon, item.fsLat]),
          zoom: 15
        })
      });

      const startCoords = olProj.fromLonLat([item.fsLon, item.fsLat]);
      const destinationCoords = olProj.fromLonLat([item.fDLon, item.fDLat]);

      const startFeature = new Feature({
        geometry: new Point(startCoords)
      });

      const destFeature = new Feature({
        geometry: new Point(destinationCoords)
      });

      const startIcon = new Icon({
        src: '../../assets/Img/marker4.png',
        size: [48, 48],
      });


      const destIcon = new Icon({
        src: '../../assets/Img/marker5.png',
        size: [48, 48]
      });


      startFeature.setStyle(new Style({
        image: startIcon, text: new Text({
          text: 'مبدأ', // Replace with desired text
          offsetY: -30, // Adjust the vertical position
          font: '16px Vazir', // Set the font style
          fill: new Fill({ color: 'Green' }), // Set the text color
          stroke: new Stroke({ color: 'blue', width: 1 })

        })
      }));
      destFeature.setStyle(new Style({
        image: destIcon, text: new Text({
          text: 'مقصد', // Replace with desired text
          offsetY: -30, // Adjust the vertical position
          font: '16px Vazir', // Set the font style
          fill: new Fill({ color: 'Red' }), // Set the text color
          stroke: new Stroke({ color: 'blue', width: 1 })
        })
      }));


      const apiKey = '5b3ce3597851110001cf6248f929f5c0617b429ba92f0e10df39ced9';
      const apiUrl = `https://api.openrouteservice.org/v2/directions/driving-car?api_key=${apiKey}&start=${item.fsLon},${item.fsLat}&end=${item.fDLon},${item.fDLat}`;

      axios1.get(apiUrl)
        .then(response => {

          const routeCoordinates = response.data.features[0].geometry.coordinates;
          const transformedRouteCoordinates = routeCoordinates.map((coord: any) => olProj.fromLonLat([coord[0], coord[1]]));

          const routeData = response.data.features[0];
          ;

          this.path.controls['duration'].setValue(this.formatDuration(routeData.properties.summary.duration));
          this.path.controls['distance'].setValue((routeData.properties.summary.distance / 1000).toFixed(2));
          const routeGeometry = new LineString(transformedRouteCoordinates);

          const routeFeature = new Feature({
            geometry: routeGeometry
          });

          const routeStyle = new Style({
            stroke: new Stroke({
              color: 'blue',
              width: 3,
              lineDash: [6, 6]
            }),
          });

          routeFeature.setStyle(routeStyle);

          const vectorSource = new VectorSource({
            features: [startFeature, destFeature, routeFeature]
          });


          this.vectorLayer = new VectorLayer({
            source: vectorSource
          });

          this.map.addLayer(this.vectorLayer);

          const iconCoordinates = [startCoords, destinationCoords];
          const boundingBox = new LineString(iconCoordinates).getExtent();
          this.map.getView().fit(boundingBox, { padding: [50, 50, 50, 50] });
        })
        .catch(error => {
          console.error('Error fetching route:', error);
        });

    }, 500);
  }

  formatDuration(duration: any) {
    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor((duration % 3600) / 60);
    return `${hours}:${minutes}`;
  }

  setActiveTab(tabNo: any) {
    let current = <HTMLElement>document.getElementById(String(this.menuType));
    current?.classList.remove('active');
    this.menuType = tabNo;
    let element = <HTMLElement>document.getElementById(String(this.menuType));
    element.classList.add('active');
    this.isLoading = true;
    this.trips = '';
    switch (tabNo) {
      case 'confirm':
        this.getTrips(1)
        break;
      case 'DriverConfirm':
        this.getTrips(2)
        break;
      case 'ongoing':
        this.getTrips(3)
        break;
      case 'aborted':
        this.getTrips(8)
        break;
      case 'planned':
        this.getTrips(10)
        break;
      default:
        break;
    }
  }

  async getTrips(type: number) {

    let model = this.otherService.stringNumberToNumber({

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      tiAppUsage: 1,

      tiTripStatus: type

    })

    let res = JSON.parse((await axios.post(`OffitialTrip_List`, model)).data.toString());

    if (res.ISSessionExpired == true) {

      this.notify.showError('نشست کاربری شما منقضی شده است');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xxaQZa' } });

      return;

    }

    if (res.iResult == 0) {

      this.notify.showError(res.strError);

      return;
    }

    this.trips = res;

    this.list_Search = res;

    this.isLoading = false;

    this.bCluster = false;

  }

  filterResult(val: any) {

    this.trips = this.list_Search.filter((el: any) => {

      return el.ClusterId?.toString() === val.value

        || el?.iOfficialTrip?.toString().includes(val.value)

        || el?.strTripImportance_strComment?.includes(val.value)

        || el?.strTripTime?.includes(val.value)

        || el?.strFullName?.includes(val.value)

        || el?.strSourceAddress?.includes(val.value)

        || el?.strDestinationAddress?.includes(val.value)

        || el?.strUserManager_Chart_strComment?.includes(val.value)

        || el?.strApplicantName?.includes(val.value)

        || el?.strApplicantFamily?.includes(val.value);

    });

    if (val.value.trim() == '') {

      this.trips = this.list_Search

    }

  }

  isSelected(item: any): boolean {

    return this.lstPassenger.indexOf(item) !== -1;

  }

  setCheckBox(value: boolean, item: any) {

    if (value === true) this.lstPassenger.push(item.iOfficialTrip);

    else {

      this.lstPassenger.find((value: any) => {

        if (value === item.iOfficialTrip) {

          const index = this.lstPassenger.indexOf(item.iOfficialTrip);

          if (index !== -1) this.lstPassenger.splice(index, 1);

        }

      })

    }


  }

  selectAllCheckBox() {

    if (this.trips.length > 0 && (this.trips.length != this.lstPassenger.length)) {

      this.lstPassenger = [];

      this.trips.forEach((a: any) => {

        this.lstPassenger.push(a.iOfficialTrip);

      })

      this.notify.showSuccess('همه انتخاب شدند')

    }

    else {

      this.lstPassenger = [];

    }

  }

  archiveTrip() {

    if (!this.lstPassenger.length) return this.notify.showError('لیست انتخابی شما خالی می باشد');

    $.confirm({

      title: `آیا از بایگانی ${this.lstPassenger.length} مورد اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            let model = this.otherService.stringNumberToNumber({

              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              lstiOffitialTrip: this.lstPassenger,

            })

            this.otherService.Showspinner()

            let res = JSON.parse((await axios.post(`OffitialTrip_ArchiveGroup`, model)).data.toString());

            this.otherService.nonespinner()

            if (res.iResult == 0) {

              this.lstPassenger = [];

              return this.notify.showError(res.strError)

            }

            this.trips = this.trips.filter((el: any) => {

              for (const passenger of this.lstPassenger) {

                if (el.iOfficialTrip.toString().includes(passenger.toString())) {

                  return false;

                }

              }

              return true;

            });

            this.lstPassenger = [];

            this.notify.showSuccess('عملیات با موفقیت انجام شد');

            this.setActiveTab(this.menuType);

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });



  }

  //Archive trip

  async ArchiveTrip(modalName: any) {

    if (confirm(`آیا از بایگانی سفر با کد ${this.currentRecord.iOfficialTrip} اطمینان دارید؟`)) {

      let model = this.otherService.stringNumberToNumber({

        strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

        iOffitialTrip: this.currentRecord.iOfficialTrip,

      })

      let res = JSON.parse((await axios.post(`OffitialTrip_Archive`, model)).data.toString());

      if (res.iResult == 0) return this.notify.showError(res.strError)

      this.notify.showSuccess('سفر مورد نظر با موقت بایگانی شد');

      $(`#${modalName}`).modal('hide');

      this.setActiveTab(this.menuType);


    }
  }

  show_DriverLocation(item: any) {

    // window.open(`/tracker/${item.strUnitID}`, '_blank');

    window.open(this.router.serializeUrl(this.router.createUrlTree(['/tracker', item.strUnitID])), '_blank');


  }

  filter_DriverResult(val: any) {

    this.drivers = this.lstDriver_Search.filter((el: any) => {

      return el?.strMobile?.includes(val.value)

        || el?.strFullName?.includes(val.value)

        || el?.strMobileDomain_strComment?.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.drivers = this.lstDriver_Search

    }

  }

  sortColumn(column: number) {

    if (column == 1) {

      this.trips.sort((a: any, b: any) => {

        return a.strRequestTime.localeCompare(b.strRequestTime);

      })


    }

    else if (column == 2) {

      this.trips.sort((a: any, b: any) => {

        return a.strSourceAddress.localeCompare(b.strSourceAddress);

      })

    }

    else {

      this.trips.sort((a: any, b: any) => {

        return a.strDestinationAddress.localeCompare(b.strDestinationAddress);

      })

    }

  }

  group_Assignment() {

    if (!this.lstPassenger.length) return this.notify.showError('لیست انتخابی شما خالی می باشد.');

    this.tiType = 0;

    $.confirm({
      title: 'یکی از موارد زیر را انتخاب کنید',

      content: `

          <form>

              <div>

                  <input type="radio" id="option1" name="choice" value="0" checked>

                  <label for="option1">مبداء یکسان</label>

              </div>

              <div>

                  <input type="radio" id="option2" name="choice" value="1">

                  <label for="option2">مقصد یکسان</label>

              </div>

              <div>

                  <input type="radio" id="option3" name="choice" value="2">

                  <label for="option3">عادی</label>

              </div>

          </form>

      `,

      buttons: {

        confirm: {

          text: 'تایید',

          btnClass: 'btn-blue',

          action: () => {

            let selectedOption = $('input[name="choice"]:checked').val();

            this.tiType = selectedOption;

            this.getDriversList()

          }

        },

        cancel: {

          text: 'بستن',

        }

      }

    });



  }

  async get_driverPlan(item: any, event) {

    event.stopPropagation();

    let model = this.otherService.stringNumberToNumber({

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strUnitID: item.strUnitID

    })

    this.otherService.Showspinner();

    let res = JSON.parse((await axios.post(`OffitialTrip_DriverPlannedTrips`, model)).data.toString());

    this.otherService.nonespinner();

    if (!res.length) return this.notify.showError('سفری برای راننده برنامه ریزی نشده است');

    this.lst_DriverPlan = res;

    $('#driver_Plan').modal('show');


  }

  openClustering() {

    this.mdl_Cluster.patchValue({

      tiPassengers: 3,

      fMaxDistanceInKm: 1,

      iMinute: 30,

    })

    $("#Modal_Clustering").modal("show")


  }

  async search_Cluster() {

    if (this.mdl_Cluster.invalid) return this.notify.showError('فرم را با دقت تکمیل کنید');

    this.otherService.Showspinner();

    let res = JSON.parse((await axios.post(`OffitialTrip_Clusterer`, this.otherService.stringNumberToNumber(this.mdl_Cluster.value))).data.toString());

    this.otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this.notify.showError('نشست کاربری شما منقضی شده است');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xxaQZa' } });

      return;

    }

    if (res.iResult == 0) {

      this.notify.showError(res.strError);

      return;
    }

    this.trips = res;

    this.list_Search = res;

    this.bCluster = true;

    $("#Modal_Clustering").modal("hide")


  }

  getRowColor(clusterId: number): string {

    if (!this.clusterColorMap.has(clusterId)) {

      const color = this.hashColor(clusterId);

      this.clusterColorMap.set(clusterId, color);

    }

    return this.clusterColorMap.get(clusterId)!;
  }

  hashColor(id: number): string {

    // return '#ffff';

    const hue = (id * 137) % 360;

    return `hsl(${hue}, 60%, 80%)`;

  }


}
